/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import {
  browserVersion,
  isChrome,
  isMac,
  isMobile,
  isWindows,
  platformVersion,
  Version,
} from './ClientService';

// see https://support.logmeininc.com/gotomeeting/help/system-requirements-for-attendees-g2m010003
// for Instant Join system requirements
const minimalInstantJoinChromeVersion = 57;

// see https://support.logmeininc.com/gotomeeting/help/what-are-the-system-requirements-for-using-the-desktop-app-g2m090014
// for Native Endpoint system requirements
const minimalNativeEndpointWindowsVersion: Version = { major: 6, minor: 1 };
const minimalNativeEndpointMacVersion: Version = { major: 10, minor: 9 };

const isVersionSupported = (required: Version, actual: Version): boolean => {
  return (
    (actual.major === required.major && actual.minor >= required.minor) ||
    actual.major > required.major
  );
};

export const isMobileJoinTechnicallySupported: boolean = isMobile;

export const isInstantJoinTechnicallySupported: boolean =
  isChrome && browserVersion >= minimalInstantJoinChromeVersion && !isMobile;

export const isNativeEndpointTechnicallySupported: boolean =
  (!isMobile &&
    isWindows &&
    isVersionSupported(minimalNativeEndpointWindowsVersion, platformVersion)) ||
  (isMac &&
    isVersionSupported(minimalNativeEndpointMacVersion, platformVersion));

export const isGrayOutOnJoinPageDesired: boolean = isChrome;
